import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';

export interface Opciones {
  headers?: HttpHeaders;
  params?: HttpParams;
  withCredentials?: boolean;
  context?: HttpContext;
}
@Injectable()
export class HttpService {
  private readonly http = inject(HttpClient);

  public doGet<T>(urlServicio: string, opciones?: Opciones): Observable<T> {
    const opcionesCalculadas = this.crearOpciones(opciones);
    return this.http.get<T>(urlServicio, opcionesCalculadas);
  }

  public doPost<T, R>(urlServicio: string, parametros: T, opciones?: Opciones): Observable<R> {
    const opcionesCalculadas = this.crearOpciones(opciones);

    return this.http.post<R>(urlServicio, parametros, opcionesCalculadas);
  }

  public doPut<T, R>(urlServicio: string, parametros: T, opciones?: Opciones): Observable<R> {
    const opcionesCalculadas = this.crearOpciones(opciones);

    return this.http.put<R>(urlServicio, parametros, opcionesCalculadas);
  }

  public doPatch<T, R>(urlServicio: string, parametros: T, opciones?: Opciones): Observable<R> {
    const opcionesCalculadas = this.crearOpciones(opciones);

    return this.http.patch<R>(urlServicio, parametros, opcionesCalculadas);
  }

  public doDelete<R>(urlServicio: string, opciones?: Opciones): Observable<R> {
    const opcionesCalculadas = this.crearOpciones(opciones);

    return this.http.delete<R>(urlServicio, opcionesCalculadas);
  }

  public setHeader(nombre: string, valor: string): Opciones {
    const opcionesPorDefecto = this.crearOpcionesPorDefecto();
    if (opcionesPorDefecto.headers) {
      opcionesPorDefecto.headers = opcionesPorDefecto.headers.set(nombre, valor);
    }
    return opcionesPorDefecto;
  }

  private crearOpciones(opciones?: Opciones): Opciones {
    const opcionesPorDefecto = this.crearOpcionesPorDefecto();
    const opcionesCombinadas = this.combinarOpciones(opcionesPorDefecto, opciones);

    if (this.debeAgregarTipoContenido(opcionesCombinadas, opcionesPorDefecto)) {
      const tipoContenidoPorDefecto = opcionesPorDefecto.headers?.get('Content-Type') ?? 'application/json';
      opcionesCombinadas.headers = opcionesCombinadas.headers?.set('Content-Type', tipoContenidoPorDefecto);
    }

    return opcionesCombinadas;
  }

  private crearOpcionesPorDefecto(): Opciones {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
  }

  private combinarOpciones(opcionesPorDefecto: Opciones, opcionesPersonalizadas?: Opciones): Opciones {
    return {
      ...opcionesPorDefecto,
      ...opcionesPersonalizadas,
      headers: opcionesPersonalizadas?.headers ?? opcionesPorDefecto.headers,
      params: opcionesPersonalizadas?.params ?? opcionesPorDefecto.params,
      withCredentials: opcionesPersonalizadas?.withCredentials ?? false,
      context: opcionesPersonalizadas?.context ?? opcionesPorDefecto.context,
    };
  }

  private debeAgregarTipoContenido(opciones: Opciones, opcionesPorDefecto: Opciones): boolean {
    const tieneHeaders = Boolean(opciones.headers);
    const tipoContenidoActual = opciones.headers?.get('Content-Type');
    const tipoContenidoDefecto = opcionesPorDefecto.headers?.get('Content-Type');

    return tieneHeaders && !tipoContenidoActual && Boolean(tipoContenidoDefecto);
  }
}
